const HEX = '0123456789abcdef'

/**
 * New MongoDB-style ObjectId as 24 lowercase hex characters (matches campaign-service
 * `draftObjectIdHexSchema` / BSON storage). Uses `crypto.getRandomValues` — no `bson` dependency.
 */
export function newObjectIdHex(): string {
  const bytes = new Uint8Array(12)
  crypto.getRandomValues(bytes)
  let out = ''
  for (const b of bytes) {
    out += HEX[b >> 4]
    out += HEX[b & 15]
  }
  return out
}
